import theme from '../../../../theme/news12'
import redesignedTheme from '../../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css.div`
  .card-content {
    display: grid;
    column-gap: 20px;
    grid-template-areas: 
      "top img img"
      "title img img"
      "description img img"
      "... img img";
  }

  .card {
    display: block;
    background-color: ${theme.colors.white};
    margin-bottom: 20px;
    border-bottom: 2px solid ${redesignedTheme.colors.mist};
  }
  
  .category .card {
    border-bottom: 0;
    margin-top: 24px;
    margin-bottom: 0;
  }  
  
  .category .card(:first-of-type) {
    margin-top: 0;
  }
  
  .image-container {
    grid-area: img;
    display: inline-block;
    margin-bottom: 30px;
  }
  
  .top {
    grid-area: top;
    margin-top: 4px;
    margin-bottom: 0;
  }
  
  .card-title {
    grid-area: title;
    margin: 16px 0 14px;
    font-size: 19px;
  }
  
  .card-description {
    grid-area: description;
    line-height: 150%;
    margin: 0;
    color: ${redesignedTheme.colors.mineShaft};
    font-size: 14px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  
  .play-icon {
    margin-bottom: 2px;
  }  
  
  .meatball-icon {
    margin: 0;
    padding: 0;
  }
`
